<script setup lang="ts">
import {BlockProps} from "@/utils/presenters/interfaces.ts";
import {computed, ref, watch} from "vue";
import TechnicianAppointmentCreator from "@/views/TechnicianAppointmentCreator.vue";
import EditViewUtils from "@/utils/editView/EditViewUtils.ts";
import {useErrorsStore} from "@/stores/ToastDataStore.ts";
import Translator from "@/utils/common/Translator.ts";
import EntityReferenceData = namaTypes.EntityReferenceData;

const props = defineProps<BlockProps>();
const emit = defineEmits<{ (e: 'handleHide'): void }>();

const allowedToOpen = ref(false);

const fromDoc = computed<EntityReferenceData | undefined>(() => {
  const record = props.presenter.fetchRecord();
  if (!record?.id)
    return undefined;
  return {id: record.id, entityType: props.presenter.entityType, code: record.code, name1: record.name1, name2: record.name2};
});

watch(() => props.collapsed, (collapsed) => {
  if (!collapsed)
    checkAllowedToOpen(true);
}, {immediate: true});

watch(() => fromDoc.value?.id, () => {
  if (!props.collapsed)
    checkAllowedToOpen(false);
});

function checkAllowedToOpen(explainWhenBlocked: boolean) {
  allowedToOpen.value = !EditViewUtils.isNew(props.presenter.place) && !props.presenter.isDirty();
  if (allowedToOpen.value)
    return;
  if (explainWhenBlocked)
    useErrorsStore().pushErrorStr(Translator.translateId("shouldCommitToOpenGroup"));
  emit('handleHide');
}
</script>

<template>
  <q-scroll-area v-if="!collapsed && allowedToOpen && fromDoc" class="tw-h-full tw-w-full">
    <TechnicianAppointmentCreator :key="fromDoc.id" :fromDoc="fromDoc"/>
  </q-scroll-area>
</template>
